module.exports = __webpack_public_path__ + "static/media/fr.2222b6c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/localised-computers/fr.png
// module id = 297
// module chunks = 0